import { Button } from '@/components/ui/button'
import { CalendarClock, X } from 'lucide-react'
import { DateTime } from 'luxon'
import SettingsModalButton from '../molecules/SettingsModalButton'
import { useCalendarPlan } from './CalendarPlanContext'

const CalendarPlanOffer = () => {
    const { plan, request, isLoading, isDismissed, openReview, dismiss } = useCalendarPlan()
    if (isDismissed || !request || (plan && plan.actions.length === 0 && plan.unscheduled.length === 0)) return null

    const additions = plan?.actions.filter((action) => action.type === 'add').length ?? 0
    const moves = (plan?.actions.length ?? 0) - additions
    const summary = [additions && `${additions} new`, moves && `${moves} moved`].filter(Boolean).join(' · ')
    const start = plan?.start ?? `${request.date}T${request.start_time}`
    const end = plan?.end ?? `${request.date}T${request.end_time}`

    return (
        <div
            className="mb-2 rounded-gt-md border border-dashed border-border bg-background px-3 py-2.5"
            data-testid="calendar-plan-offer"
        >
            <div className="flex flex-wrap items-center gap-x-2.5 gap-y-2">
                <div className="flex size-7 shrink-0 items-center justify-center rounded-md bg-gt-violet/10">
                    <CalendarClock className="size-3.5 text-gt-violet" />
                </div>
                <div className="min-w-[11rem] flex-1">
                    <h3 className="text-title-sm text-foreground">Plan today on your calendar</h3>
                    <p className="text-body-sm text-muted-foreground">
                        {isLoading ? 'Finding open time' : summary || 'Ready to plan'} ·{' '}
                        {DateTime.fromISO(start).toFormat('h:mm a')}–{DateTime.fromISO(end).toFormat('h:mm a')}
                    </p>
                    {plan && (
                        <div className="mt-1 flex gap-1 overflow-hidden" aria-label="Suggested blocks">
                            {plan.actions.slice(0, 4).map((action) => (
                                <span
                                    key={action.id}
                                    className="max-w-32 truncate rounded border border-dashed border-gt-violet/40 bg-gt-violet/5 px-1.5 py-0.5 text-label-sm text-foreground"
                                >
                                    {action.title}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
                <div className="ml-auto flex shrink-0 items-center gap-1">
                    <SettingsModalButton type="icon-button" label="Auto-block settings" defaultTabIndex={1} />
                    <Button
                        size="sm"
                        onClick={openReview}
                        className="bg-action text-action-foreground hover:bg-action-hover"
                    >
                        Auto-block
                    </Button>
                    <Button size="sm" variant="ghost" aria-label="Not now" onClick={dismiss} className="size-7 p-0">
                        <X className="size-4" />
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default CalendarPlanOffer
